import { useState } from "react";
import { Alert, Button, Card, Flex, Form, Input, Modal } from "antd";

import { useAuth } from "context/providers/auth";

const ModalDeleteCompany = () => {
  const {
    state: {
      user: { company },
    },
    deleteCompany,
  } = useAuth();

  const [is_open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async ({ password }) => {
    setLoading(true);
    try {
      await deleteCompany({ password });

      setOpen(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      form.resetFields();
    }
  };

  return (
    <Card className="m-t-20" title="Usuń konto">
      <Alert
        className="m-b-20"
        showIcon
        message="Wszystkie powiązane dane (np. zgłoszenia, pracownicy, klienci) zostaną trwale usunięte!"
        type="error"
      />
      <Flex justify="center">
        <Button
          danger
          type="primary"
          htmlType="button"
          onClick={() => setOpen(true)}
        >
          Usuń konto
        </Button>
      </Flex>

      {is_open && (
        <Modal
          style={{ top: 45 }}
          title="UWAGA!"
          open={is_open}
          onOk={() => form.submit()}
          onCancel={() => setOpen(false)}
          confirmLoading={loading}
          cancelText="Anuluj"
          okText="Potwierdzam"
          okType="danger"
        >
          <p>
            Czy na pewno chcesz usunąć firmę <strong>{company?.name}</strong>?
          </p>
          <p>
            Wszystkie powiązane dane (np. zgłoszenia, pracownicy, klienci)
            zostaną trwale usunięte!
          </p>
          <p>Potwierdź usunięcie konta wprowadzając hasło poniżej.</p>
          <Form
            form={form}
            layout="vertical"
            initialValues={{
              password: "",
            }}
            onFinish={onFinish}
          >
            <Form.Item
              label="Hasło"
              name="password"
              required
              hasFeedback
              rules={[
                { required: true, message: "Podaj swoje hasło" },
                { min: 6, message: "Hasło powinno mieć przynajmniej 6 znaków" },
              ]}
            >
              <Input.Password placeholder="Wprowadź hasło" />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </Card>
  );
};

export default ModalDeleteCompany;
